import React from 'react';

const AnalysisTab: React.FC = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Analysis Dashboard
        </h2>
        <p className="text-gray-600">
          Analysis functionality coming soon...
        </p>
      </div>
    </div>
  );
};

export default AnalysisTab;